var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('BRow', {
    staticClass: "mb-3"
  }, [_c('BCol', {
    attrs: {
      "cols": "12"
    }
  }, [_c('BFormTextarea', {
    attrs: {
      "id": "metaDataBox",
      "rows": 10,
      "readonly": true,
      "value": _vm.salesOrderMetadata,
      "label": "Metadata",
      "outlined": "",
      "dense": "",
      "required": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: _vm.salesOrderMetadata,
      callback: function ($$v) {
        _vm.salesOrderMetadata = $$v;
      },
      expression: "salesOrderMetadata"
    }
  }), _c('OmniButtonCollection', [_c('OmniButton', {
    staticClass: "mt-2 mr-2",
    on: {
      "click": _vm.selectAll
    }
  }, [_c('span', {
    staticClass: "icon mr-1"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": "i-cursor"
    }
  })], 1), _c('span', {
    staticClass: "label"
  }, [_vm._v(" Alles selecteren ")])]), _c('OmniButton', {
    staticClass: "mt-2",
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_c('span', {
    staticClass: "icon mr-1"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": "copy"
    }
  })], 1), _c('span', {
    staticClass: "label"
  }, [_vm._v(" Kopiëren ")])])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }